import { Pagination, EffectFade, Swiper } from 'swiper';

export default class Block10 {
    constructor (query) {
        const elems = document.querySelectorAll(query);
        if (!elems || !elems.length) return;

        this.query = query;
        this.elems = [...elems];

        this.init();
    }

    init () {
        this.setupSlider();
    }

    setupSlider () {
        this.elems.forEach((elem) => {
            const slider = elem.querySelector(`${this.query}__slider`);
            if (!slider) return;

            new Swiper(slider, {
                modules: [Pagination, EffectFade],
                loop: true,
                effect: 'fade',
                speed: 600,
                pagination: {
                    el: elem.querySelector(`${this.query}__slider--pagination`),
                    clickable: true
                },
                autoplay: { delay: 2000 }
            });
        });
    }
}
